var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-editor',{attrs:{"readonly":!_vm.isGranted('UPDATE_REPORT_NOTES'),"toolbar":[
    [
      {
      label: 'Header Styles',
      list: 'no-icons',
      options: ['h1','h2','h3','h4','h5','h6' ],
      }
    ], ['bold', 'italic', 'strike', 'underline'],
    ['quote', 'unordered', 'ordered', 'outdent', 'indent'],
    ['undo', 'redo'],
    ['save']
  ]},scopedSlots:_vm._u([{key:"save",fn:function(){return [(_vm.isLoading)?_c('span',{staticClass:"text-subtitle2 text-secondary"},[_vm._v("\n        Updating notes...\n        "),_c('q-icon',{attrs:{"name":"fas fa-circle-notch fa-spin"}})],1):_vm._e()]},proxy:true}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }